import type { FC, ReactElement } from 'react';

import { useSubtitlesViewport } from '../../components/subtitles/hooks/useSubtitlesViewport';
import { SubtitlesBitMask } from '../../logger/bitMasks/SubtitlesBitMask';
import { Logger } from '../../logger/Logger';
import { L10nText } from '../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../store/CoreStore';
import { useSubtitlesSlice } from '../../store/slices/subtitles/selectors';
import { subtitlesActions } from '../../store/slices/subtitles/slice';
import { ControlContainer } from '../controls/controlContainer/ControlContainer';
import { RadioGroup } from '../controls/radioGroup/RadioGroup';
import { SubtitlesPreview } from '../subtitles/preview/SubtitlesPreview';
import { SubtitlesTextSize } from '../subtitles/types';

import styles from './SettingsSubtitles.module.css';

export const SettingsSubtitlesConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const { deviceType } = useSubtitlesViewport();
  const isSubtitlesEnabled = useSubtitlesSlice.isEnabled();
  const subtitlesSize = useSubtitlesSlice.sizes();

  return (
    <ControlContainer label={<L10nText tk="SETTINGS_SUBTITLES_SIZE" />} column offset>
      <RadioGroup
        className={styles.subtitlesSettingsSize}
        disabled={!isSubtitlesEnabled}
        name="settings-subtitles-size"
        options={[
          {
            label: <L10nText tk="SETTINGS_SUB_SMALL" />,
            value: SubtitlesTextSize.SMALL.toString(),
          },
          {
            label: <L10nText tk="SETTINGS_SUB_MEDIUM" />,
            value: SubtitlesTextSize.MEDIUM.toString(),
          },
          {
            label: <L10nText tk="SETTINGS_SUB_LARGE" />,
            value: SubtitlesTextSize.LARGE.toString(),
          },
        ]}
        onChange={(value) => {
          const subtitleSize = value as SubtitlesTextSize;
          dispatch(subtitlesActions.setSize({ deviceType, size: subtitleSize }));

          SubtitlesBitMask.resetSize(deviceType);
          SubtitlesBitMask.applySizeMask(deviceType, subtitleSize);
          Logger.logEvent('subtitles_size_changed', { bandwidth: SubtitlesBitMask.maskedBinary });
        }}
        value={subtitlesSize[deviceType].toString()}
      />
      <SubtitlesPreview sizes={subtitlesSize} subtitle={<L10nText tk="SETTINGS_SUB_PREVIEW" />} />
    </ControlContainer>
  );
};
